/** @type {Styles} */

export const styles = {
  spacer: {
    marginX: 0.5,
  },
  flexRow: {
    display: 'flex',
    flexDirection: 'row',
  },
  noPadding: {
    '.MuiAccordionDetails-root': {
      padding: 0,
    },
  },
  openedMultiplePaymentWrapper: {},
  openedSummary: {
    '& .MuiAccordionSummary-content': {
      marginBottom: 0,
    },
  },
  internalDividerWithOneType: {
    marginTop: 2,
  },
  multiplePaymentWrapper: {
    paddingTop: 1,
    paddingBottom: 0.5,
    display: 'flex',
    flexDirection: 'column',
  },
  buttonWrapper: {
    marginTop: 1,
    marginBottom: 2,
  },
  firstButtonWrapper: {
    marginTop: 1,
    marginBottom: 2,
  },
  internalDivider: {
    borderColor: 'gray.8',
    marginBottom: 0.75,
  },
  accordionContent: {
    padding: 0,
    marginBottom: 2,
  },
  accordionSummary: {
    border: 0,
    marginLeft: 0,
    marginRight: 0,
    '& .MuiAccordionSummary-content': {
      marginBottom: 1,
      marginTop: 1,
    },
    '& .MuiAccordionSummary-expandIconWrapper': {
      marginRight: 0,
    },
  },
  multipleAccordionContent: { paddingLeft: 0 },
  openedSummarySingle: {
    '& .MuiAccordionSummary-content': {
      marginBottom: 1,
      marginTop: 0.75,
    },
  },
}
